const base = "#0A0A0A";
const secondary = "#898989";
const PICNumber = "6287881930558";

export {
    base,
    secondary,
    PICNumber
}